// @ts-nocheck
/* eslint-disable */
import { getDetailSize } from "~/util/cdn";
/**
 * Tvorba nahledoveho obrazku do detailu
 */
Mapy.Pano.Image = class {
	/**
	 * @param {SMap.Pano.Place} place
	 * @param {SceneCoords} [coords] Volitelne souradnice bodu, na ktery chceme koukat
	 */
	constructor(place, coords, options) {
		this._options = {
			width: 100,
			height: 100
		};

		for (var p in options) { this._options[p] = options[p]; }

		this._data = {
			coords: coords,
			place: place
		};

		this._params = null;
	}

	setPano() {
		var place = this._data.place;
		var yawValue = place.getLookDir() !== null ? place.getLookDir() : place.getKappa();
		var size = getDetailSize();

		var params = {
			// def pitch, fov
			pitch: -0.066,
			fov: 1.570,
			yaw: yawValue / 180 * Math.PI,
			// dimensions from detail
			width: size.width,
			height: size.height,
			pid: place.getId()
		};

		if (params.yaw != 0) {
			params.yaw = params.yaw.toFixed(3);
		}

		var img = new Image();
		img.crossOrigin = "anonymous";
		img.src = Mapy.Util.panoCompose(params);

		this._params = params;

		return img;
	}

	getParams() {
		return this._params;
	}
};
